import React, { createContext, useContext, useState } from 'react';

const QuizContext = createContext();

export const useQuiz = () => {
  const context = useContext(QuizContext);
  if (!context) {
    throw new Error('useQuiz must be used within QuizProvider');
  }
  return context;
};

export const QuizProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState({ email: '', name: '' });
  const [flowStage, setFlowStage] = useState('unauthenticated');
  const [mcqAnswers, setMcqAnswers] = useState({});
  const [emailAnswers, setEmailAnswers] = useState({});
  const [microsoftLinkAnswer, setMicrosoftLinkAnswer] = useState(null);
  const [finalTestId, setFinalTestId] = useState(null);
  const [finalChallenge, setFinalChallenge] = useState(null);
  const [attemptToken, setAttemptToken] = useState(null);
  const [questionSet, setQuestionSet] = useState([]);
  const [emailSet, setEmailSet] = useState([]);
  const [allowResults, setAllowResults] = useState(false);

  const resetQuiz = () => {
    setMcqAnswers({});
    setEmailAnswers({});
    setMicrosoftLinkAnswer(null);
    setFinalTestId(null);
    setFinalChallenge(null);
    setAttemptToken(null);
    setQuestionSet([]);
    setEmailSet([]);
    setAllowResults(false);
  };

  

  return (
    <QuizContext.Provider
      value={{
        userInfo,
        setUserInfo,
        flowStage,
        setFlowStage,
        mcqAnswers,
        setMcqAnswers,
        emailAnswers,
        setEmailAnswers,
        microsoftLinkAnswer,
        setMicrosoftLinkAnswer,
        finalTestId,
        setFinalTestId,
        finalChallenge,
        setFinalChallenge,
        attemptToken,
        setAttemptToken,
        resetQuiz,
        questionSet,
        setQuestionSet,
        emailSet,
        setEmailSet,
        allowResults,
        setAllowResults,
      }}
    >
      {children}
    </QuizContext.Provider>
  );
};
